export default "__VITE_PUBLIC_ASSET__a938b0ca__"